module.exports = "/Frontend/logo.6ee805fe81d48ff9dcd7eed366bfad8c.png";